import { call, put, takeLatest, select } from 'redux-saga/effects';
import pickBy from 'lodash/pickBy';
import { get } from 'lodash';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { getSortParams } from '../helpers/utils';
import { FETCH_ARCHIVE_ACCEPTED, FETCH_ARCHIVE_ACCEPTED_FAIL, FETCH_ARCHIVE_ACCEPTED_SUCCESS } from '../redux/ArchiveTables';
import { SET_LOADER } from '../redux/Loader';
import { ACCEPTED } from '../consts/navigation';

function* fetchArchiveAcceptedFlow() {
  try {
    yield put(SET_LOADER({ value: true, }));
    const sortData = yield select((state) => get(state, ['tables', ACCEPTED, 'sort']));
    const queryValue = yield select((state) => get(state, ['tables', ACCEPTED, 'queryValue']));
    const limitValue = yield select((state) => get(state, ['tables', ACCEPTED, 'rowsPerPage']));
    const page = yield select((state) => get(state, ['tables', ACCEPTED, 'page']));
    const vehicleType = yield select((state) => state.vehicleType.vehicleType);

    const params = pickBy(
      {
        ...getSortParams(sortData),
        query: queryValue,
        limit: limitValue,
        page,
      },
      (val) => Boolean(val)
    );

    const endpoint = `${apiRoot}/${vehicleType}/archive_offers/accepted`;
    const data = yield call(apiCall, { method: 'GET', endpoint, params, });
    yield put(FETCH_ARCHIVE_ACCEPTED_SUCCESS(data));
  } catch (error) {
    yield put(FETCH_ARCHIVE_ACCEPTED_FAIL(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* FetchArchiveAccepted() {
  yield takeLatest(FETCH_ARCHIVE_ACCEPTED, fetchArchiveAcceptedFlow);
}
